import React, { PropsWithChildren, useRef } from 'react'
import clsx from 'clsx'
import { Loader } from '../Loader'
import styles from './styles/ButtonLink.module.scss'

export type ButtonLinkProps = PropsWithChildren & {
  underline?: boolean
  disabled?: boolean

  /**
   * FIXME: remove and push disabling to parent
   * @deprecated
   */
  disableOnClick?: boolean
  isLoading?: boolean
  className?: string
  highlight?: boolean
  onClick?: () => void
}

export const ButtonLink = React.forwardRef<HTMLButtonElement, ButtonLinkProps>((props, ref) => {
  const { disabled, disableOnClick, isLoading, underline, className, highlight, onClick, children, ...rest } = props

  /**
   * FIXME: remove with disableOnClick prop
   */
  const buttonRef = useRef<HTMLButtonElement>(null)
  const showLoader = isLoading !== undefined

  /**
   * FIXME: remove with disableOnClick prop
   * The current implementation has no way to re-enable the button
   */
  const handleClick = () => {
    if (disableOnClick) {
      if (buttonRef.current && !buttonRef.current.disabled) {
        buttonRef.current.disabled = true
        onClick?.()
      }
    } else {
      onClick?.()
    }
  }

  return (
    <button
      ref={ref ?? buttonRef}
      disabled={disabled || isLoading}
      onClick={handleClick}
      type="button"
      data-render-variant="link"
      className={clsx(
        styles.buttonLink,
        underline && !disabled && styles.underline,
        highlight && styles.highlight,
        className
      )}
      {...rest}
    >
      {showLoader && <Loader open={Boolean(isLoading)} variant="dark" />}
      {children}
    </button>
  )
})
